import request from '@/utils/request'
import store from '@/store'
// 获取地区数据列表
export function fetchAreaList(data) {
	return request({
		url: '/dataModule/areaInfo',
		method: 'post',
		data: {
			...data,
		},
	})
}
// 获取路线数据列表
export function fetchRouteList(data) {
	return request({
		url: '/dataModule/routeInfo',
		method: 'post',
		data: {
			...data,
		},
	})
}

export function fetchComList(data) {
	return request({
		url: '/basicData/comDict',
		method: 'get',
	})
}
